function getOrigin(): string {
  return typeof window !== 'undefined' ? window.location.origin : '';
}

function withSiteOrigin(url: string): string {
  const siteOrigin = getOrigin();
  if (!siteOrigin) return url;
  const joiner = url.includes('?') ? '&' : '?';
  return `${url}${joiner}siteOrigin=${encodeURIComponent(siteOrigin)}`;
}

export function getEventPreviewUrl(eventId: string): string {
  return `${getOrigin()}/?eventPreview=${encodeURIComponent(eventId)}#upcoming-events`;
}

export function getClassPreviewUrl(classId: string): string {
  return `${getOrigin()}/classes?preview=${encodeURIComponent(classId)}`;
}

export function getEventShareUrl(eventId: string): string {
  return withSiteOrigin(`${getOrigin()}/share/events/${encodeURIComponent(eventId)}`);
}

export function getProjectShareUrl(projectId: string): string {
  return withSiteOrigin(`${getOrigin()}/share/projects/${encodeURIComponent(projectId)}`);
}

export function getClassShareUrl(classId: string): string {
  return withSiteOrigin(`${getOrigin()}/share/classes/${encodeURIComponent(classId)}`);
}

export function getNoticeShareUrl(noticeId: string): string {
  return withSiteOrigin(`${getOrigin()}/share/notices/${encodeURIComponent(noticeId)}`);
}
